import React from "react";
import { Badge } from "@/components/ui/badge";

const SECTIONS = [
  ["word_overview", "Word / Name Overview"],
  ["litraroot", "Litraroot"],
  ["litracharge", "Litracharge"],
  ["litrabonds", "Litrabonds"],
  ["litrasequence", "Litrasequence"],
  ["litraframe", "Litraframe"],
  ["litraseal", "Litraseal"],
  ["wordbody", "Wordbody"],
  ["vowel_field", "Vowel Field"],
  ["consonant_engine", "Consonant Engine"],
  ["repetition_pattern", "Repetition Pattern"],
  ["word_class", "Word Class"],
  ["status_signal", "Status Signal"],
  ["archetype_signal", "Archetype Signal"],
  ["shadow_pattern", "Shadow Pattern"],
  ["brand_identity_use", "Brand / Identity Use"],
  ["suggested_taglines", "Suggested Taglines"],
  ["suggested_content_angles", "Suggested Content Angles"],
  ["final_litrabind_statement", "Final Litrabind Statement"],
  ["shareable_card_text", "Shareable Card Text"],
  ["missions_unlocked", "Missions Unlocked"],
];

const Block = ({ index, title, value }) => {
  const isList = Array.isArray(value);
  return (
    <section className="py-4 border-b border-white/[0.06] last:border-0 fade-in" data-testid={`report-section-${index}`}>
      <div className="flex items-baseline gap-3">
        <span className="mono-chip text-[var(--bone-faint)] w-7 shrink-0">{String(index).padStart(2, "0")}</span>
        <div className="flex-1">
          <h4 className="text-sm font-display font-semibold green-text uppercase tracking-wide">{title}</h4>
          {isList ? (
            <ul className="mt-2 space-y-1.5">
              {value.map((v, i) => (
                <li key={i} className="text-[var(--bone-muted)] text-sm leading-relaxed flex gap-2">
                  <span className="green-text">•</span><span>{v}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="mt-1.5 text-[var(--bone-muted)] text-sm leading-relaxed" style={{ maxWidth: "68ch" }}>{value}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export const DecodeFullReport = ({ report, inputText }) => {
  if (!report) return null;
  return (
    <div className="litra-card p-5 sm:p-7" data-testid="decode-full-report">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
        <h3 className="text-xl font-display font-semibold">Full Litrametry Report · {inputText}</h3>
        <Badge className={report.generated_by === "ai" ? "gold-edge gold-text bg-transparent" : ""} variant="outline">
          {report.generated_by === "ai" ? "AI-assisted" : "Rule-based"}
        </Badge>
      </div>
      <div className="divide-y divide-white/[0.04]">
        {SECTIONS.map(([key, title], i) =>
          report[key] != null ? <Block key={key} index={i + 1} title={title} value={report[key]} /> : null
        )}
      </div>
      {report.disclaimer && (
        <p className="mt-5 text-xs text-[var(--bone-faint)] italic border-t border-white/[0.06] pt-4">{report.disclaimer}</p>
      )}
    </div>
  );
};

export default DecodeFullReport;
